import React from 'react';
import { AxlPanel, AxlButton, AxlTextArea } from 'axl-reactjs-ui';
import {inject, observer} from "mobx-react";

import styles, * as E from './styles';

@inject('shipmentStore', 'deliveryStore')
@observer
class ShipmentCancel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: ''
    }
  }


  onUpdate = (name) => (e) => {
    if (e.target.value !== undefined) {
      this.setState({[name]: e.target.value});
    }
  }

  save = () => {
    const {shipmentStore, shipment, onClose, deliveryStore} = this.props;

    if (!shipment || !this.state.reason || this.state.reason.trim() === '') return;

    shipmentStore.cancelShipment(shipment.id, this.state.reason, () => {
      onClose();
      deliveryStore.loadShipments();
    })
  }

  render() {
    const {cancelingShipment} = this.props.shipmentStore;

    return <E.Container style={styles.Container}>
      <div style={styles.HeaderTitle}>{`Cancel reason`}</div>
      <AxlPanel>
        <AxlPanel.Row>
          <AxlPanel.Col style={styles.GroupPanel}>
            <div style={styles.GroupField}>
              <div style={styles.Field}>
                <AxlTextArea  value={this.state.reason} onChange={this.onUpdate('reason')} name='reason' placeholder={`Reason...`} style={styles.TextField} fluid />
              </div>
            </div>
          </AxlPanel.Col>
        </AxlPanel.Row>
        <AxlPanel.Row>
          <AxlPanel.Col>
            <AxlPanel.Row align={`center`}>
              <div style={{...styles.Field, ...styles.FieldButton}}><AxlButton compact bg={`gray`} onClick={this.props.onClose} style={styles.buttonControl}>{`Cancel`}</AxlButton></div>
              <div style={{...styles.Field, ...styles.FieldButton}}><AxlButton compact bg={`pink`} loading={cancelingShipment} disabled={!this.state.reason} onClick={this.save} style={styles.buttonControl}>{`Save`}</AxlButton></div>
            </AxlPanel.Row>
          </AxlPanel.Col>
        </AxlPanel.Row>
      </AxlPanel>
    </E.Container>
  }
}

export default ShipmentCancel;